import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { ClientToolStatusColor } from '@core/tellent-assistant-types';
import { BadgeComponent, type BadgeColor } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assistant-cell-status',
  imports: [BadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (label()) {
      <rt-badge [color]="color()" [text]="label()" />
    }
  `,
})
export class AssistantCellStatusComponent {
  public static readonly NgInputs = [<const>'value', <const>'statusMap'];

  protected readonly label = computed(() => {
    const v = this.value();
    if (v == null) return '';
    return String(v);
  });

  protected readonly color = computed<BadgeColor>(() => {
    const semantic = this.statusMap()?.[this.label()] ?? 'default';
    return SEMANTIC_TO_BADGE_COLOR[semantic];
  });

  public readonly value = input<unknown>();
  public readonly statusMap = input<Record<string, ClientToolStatusColor> | undefined>();
}

const SEMANTIC_TO_BADGE_COLOR: Record<ClientToolStatusColor, BadgeColor> = {
  success: 'success-tint',
  warning: 'warning-tint',
  rejected: 'rejected-tint',
  pending: 'requested-tint',
  draft: 'draft',
  info: 'info',
  default: 'default',
};
